export default "__VITE_ASSET__Dk$XaU8S__"